import { render, staticRenderFns } from "./NewProjectTableTypeList.vue?vue&type=template&id=2dcd6380&scoped=true"
import script from "./NewProjectTableTypeList.vue?vue&type=script&lang=js"
export * from "./NewProjectTableTypeList.vue?vue&type=script&lang=js"
import style0 from "./NewProjectTableTypeList.vue?vue&type=style&index=0&id=2dcd6380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd6380",
  null
  
)

export default component.exports